import React from 'react';
import Hero from '../Hero';
import AboutSection from '../Section/AboutSection';
import Banner from '../Section/BannerSection';
import Section from '../Section';
import FeaturesSection from '../Section/FeaturesSection';
import FaqSection from '../Section/FaqSection';
import { pageTitle } from '../../helpers/PageTitle';
const featureListData = [
  {
    iconSrc: '/images/icons/clock.svg',
    title: 'Save Time',
    subTitle:
      'Settling an estate takes over 500 hours of searching for resources and managing tasks.\n\nEstate Compass saves you time by centralizing everything in one place and automating key steps, from document preparation to progress tracking.',
  },
  {
    iconSrc: '/images/icons/answer.svg',
    title: 'Gain Clarity',
    subTitle:
      'Navigating estate settlement for the first time can be overwhelming, with countless steps and details you didn’t even know to look for.\n\nEstate Compass provides a clear roadmap, guiding you through every step and ensuring nothing gets missed, so you can move forward with confidence.',
  },
  {
    iconSrc: '/images/icons/respect.svg',
    title: 'Avoid Disputes',
    subTitle: `Estate Compass fosters collaboration and reduces disputes by ensuring everyone is on the same page.\n\nWith transparent progress tracking, shared access for key stakeholders, and a clear plan for the right steps, it helps prevent misunderstandings and keeps the process running smoothly.`,
  },
  {
    iconSrc: '/images/icons/integrity.svg',
    title: 'Include Experts',
    subTitle:
      'Estate Compass guides you through the process and identifies the right moments to involve professionals like attorneys or accountants.\n\nWith clear recommendations, you’ll know exactly when and where to turn for specialized expertise.',
  },
  {
    iconSrc: '/images/icons/teamwork.svg',
    title: 'Tailored Help',
    subTitle:
      'Estate Compass learns from the details you provide, tailoring its guidance to your unique estate needs while offering personalized recommendations.\n\nIt connects you with local resources and professionals to ensure each step is managed with precision and care.',
  },
];

const faqData = [
  {
    title: 'What does Estate Compass actually do?',
    content:
      'Estate Compass is software designed to guide you through every step of settling an estate. It includes a project plan where you can track tasks, record notes, and monitor progress to ensure nothing gets missed. With an AI-powered chatbot, you can ask questions based on the specific details of your estate and get tailored guidance instantly. You can also track assets, liabilities, and appraisals, manage distributions, and even fill out and submit forms—all in one place. It’s a powerful tool to stay organized, keep stakeholders in the loop, and navigate the process with confidence.',
  },
  {
    title: 'Can you handle legal or financial tasks?',
    content:
      'Estate Compass focuses on administrative support and guiding you through the estate settlement process. For legal or financial tasks, we’ll help you identify the right professionals and provide a smooth handoff when their expertise is needed.',
  },
  {
    title: 'Is this platform suitable for someone who has never settled an estate before?',
    content:
      'Absolutely! Estate Compass is designed for first-time estate executors or administrators. It simplifies the process, explains unfamiliar steps, and ensures you feel confident in managing the estate.',
  },
  {
    title: 'How much does Estate Compass cost?',
    content:
      'Estate Compass is completely free to use during our private beta. All we ask in return is that you share your feedback on the features you’ve used and let us know what additional tools or guidance would be most helpful to you. In the future, Estate Compass will transition to a simple flat-fee pricing model per estate, ensuring affordable and transparent access to all its features.',
  },
  {
    title: 'Is my data secure?',
    content:
      'At Estate Compass, your data security is our top priority. We use industry-standard encryption to protect your information both in transit and at rest. Your data is stored securely on trusted servers, and we never share your personal details with third parties without your explicit consent. Additionally, we implement strict access controls and regular security audits to ensure your information remains safe and confidential. Your trust means everything to us, and we are committed to safeguarding your privacy at every step.',
  },
  {
    title: 'How is Estate Compass different from hiring a lawyer or accountant?',
    content:
      'Estate Compass doesn’t replace professionals like lawyers or accountants but complements them by streamlining administrative tasks and ensuring you’re prepared. It helps reduce your reliance on costly services by handling much of the work yourself, with guidance every step of the way.',
  },
];

export default function Home() {
  pageTitle('Home');
  return (
    <>
      <Hero
        title="Navigate Estate Settlement with Clarity"
        subTitle="An intelligent <b>guide</b> to estate settlement: simplifying the process and keeping you on track every step of the way."
        bgUrl="/images/hero_bg.jpeg"
        imgUrl="/images/hero_img_993x971-or8.png"
        videoBtnText="See the software in action"
        videoUrl="https://www.loom.com/embed/8f2aa930acae4bb782d3b78030da4a58?sid=6a244ce7-6ab8-436b-b5d4-597be3ccc383"
        infoList={[
          {
            title: 'Step 1.',
            subTitle: 'Ask questions',
            iconUrl: '/images/icons/question.svg',
          },
          {
            title: 'Step 2.',
            subTitle: 'Get personalized answers',
            iconUrl: '/images/icons/answer.svg',
          },
          {
            title: 'Step 3.',
            subTitle: 'Track progress',
            iconUrl: '/images/icons/progress.svg',
          },
        ]}
        btnText="Try It Now"
        btnUrl="/contact"
      />
      {/* Start Feature Section */}
      <Section
        topMd={185}
        topLg={140}
        topXl={100}
        bottomMd={185}
        bottomLg={140}
        bottomXl={100}
      >
        <FeaturesSection sectionTitle="Benefits" data={featureListData} />
      </Section>
      {/* End Feature Section */}
      {/* Start About Section */}
      <Section>
        <AboutSection
          imgUrl="/images/founder.png"
          spiningImgUrl="/images/cea_circle.svg"
          title="About Us"
          subTitle="ESTATE COMPASS"
          featureList={[
            {
              featureListTitle:
                'Our founder is a Certified Executor Advisor',
              featureListSubTitle:
                'Jason Kealey, a software engineer and repeat entrepreneur, is now focused on revolutionizing estate settlement. Drawing from personal experience, Jason understands the importance of support during this time of need. By leveraging AI and innovative technology, he aims to unify the often fragmented network of professionals and resources involved in estate settlement, bringing families a seamless and guided experience when it matters most.',
            },
          ]}
        />
      </Section>
      {/* End About Section */}

      {/* Start Banner Section */}
      <Section>
        <Banner
          bgUrl="images/cta_bg.svg"
          imgUrl="images/screenshot3.png"
          title="Participate in our Beta!"
          subTitle="Apply to join our private beta and be among the first to experience the future of estate settlement."
        />
      </Section>
      {/* End Banner Section */}

      {/* Start FAQ Section */}
      <Section topMd={190} topLg={145} topXl={105}>
        <FaqSection
          data={faqData}
          sectionTitle="Any Questions?"
          sectionTitleUp="We're here to help."
        />
      </Section>
      {/* End FAQ Section */}

    </>
  );
}
